import React from 'react';

import Badge from '../common/Badge';
import { AUDIT_ACTION_CONFIG, formatAuditAction } from './auditFormatting';

function AuditActionBadge({ action }) {
  const variant = AUDIT_ACTION_CONFIG[action]?.variant || 'neutral';

  return <Badge variant={variant}>{formatAuditAction(action)}</Badge>;
}

export default AuditActionBadge;
